import { TimerStore } from '../../../common/js/TimerStore';
import { sendMonitoringVideoVastMRCViewableEvent } from '../../../common/js/TrackAnalyticsHelper';
import { RootStore } from '../../../common/js/stores/root.store';
import { reaction } from '../../../common/js/utils/preact-utils';
import VASTClient from './vast/vast-client';

export const MRC_VIEWABLE_DURATION_CRITERIA = 2000;

export class MRCViewabilityTracker {
  timer!: TimerStore;

  startMonitoring(): void {
    this.initTimer();
    this.listenToMraidViewabilityChange();
  }

  initTimer(): void {
    this.timer = new TimerStore({
      delay: MRC_VIEWABLE_DURATION_CRITERIA
    });

    this.timer.on('finish', this.sendTrack.bind(this), true);
  }

  listenToMraidViewabilityChange(): void {
    const adContainerStore = RootStore.getInstance().adContainerStore;

    //TODO: Viewability should be at least 50% of its pixels are visible for a minimum of 2 seconds
    reaction(
      () => adContainerStore.isViewable.value,
      (isViewable: boolean) => this.onViewabilityChange(isViewable),
      true
    );
  }

  onViewabilityChange(isViewable: boolean): void {
    if (isViewable) {
      this.timer.resume();
    } else {
      this.timer.pause();
    }
  }

  sendTrack(): void {
    RootStore.getInstance().videoStore.vast!.setMRCViewable();
    sendMonitoringVideoVastMRCViewableEvent();
  }
}
